import { Component, Input, Output, EventEmitter} from '@angular/core'

@Component({
  selector: 'app-st-button-filter',
  templateUrl: './st-button-filter.component.html',
  styleUrls: ['./st-button-filter.component.scss'],
  standalone: false
})
export class StButtonFilterComponent {

  @Input()
  idVal: string = 'buttonId';

  @Input()
  label = 'Edit';

  @Output()
  onClick = new EventEmitter<Event>();
}
